import CreateOrConnectHelper from '@/Utility/Association/CreateOrConnectHelper';
import ComponentManager from '@/Management/ComponentManager';

export default class ObjectConnectionHelper extends CreateOrConnectHelper {

    public ConnectionCallback: Function;
    public ObjectIdToConnect: Function;

    public constructor(params: any) {
        super(params);

        this.ConnectionCallback = this.handlerOrDefault(params.connectionCallback);
        this.ObjectIdToConnect = this.paramOrDefault(params.objectIdToConnect);

        this.disconnectionCallback = this.CallConnectionCallback;
        this.ExecuteAction = this.CallConnectionCallback;
    }

    private CallConnectionCallback() {
        this.ConnectionCallback(this.ObjectIdToConnect);
        this.state('Finished');
    }
}

ComponentManager.setUtility('ObjectConnectionHelper', ObjectConnectionHelper, 'RADPresentation.HTMLClient.DefaultViewExtensions');